import type { ReactNode } from "react";
import { useLoginApi } from "~/features/auth/login/components/LoginPopup";
import { OnboardingOverlayProvider } from "~/features/registration/hooks/OnboardingOverlayContext";

interface Props {
  children: ReactNode;
  onLoginSuccess: () => void;
}

export const OnboardingAuthenticationProvider = ({ children, onLoginSuccess }: Props) => {
  const { login, errorComponent } = useLoginApi({
    alternativeLoginAction: () => undefined,
  });

  const loginAfterRegistration = async (email: string, password: string) => {
    const loginSucceeded = await login(email, password);
    if (loginSucceeded) {
      onLoginSuccess();
    }
    return loginSucceeded;
  };

  return (
    <OnboardingOverlayProvider loginAfterRegistration={loginAfterRegistration} loginErrorComponent={errorComponent}>
      {children}
    </OnboardingOverlayProvider>
  );
};
